// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction5_wrapper__FRH5H","button":"introduction5_button__JoV-p"};